// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Neonmetropolis Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const NeonMetropolisAliensPlanets = {
  planets: {
    // Neo-Tokyo (1300) - Main cyberpunk hub
    1300: ['replicants', 'synths', 'streetsamurai', 'psychics'],
    
    // Cyber-Angeles (1301) - West coast megacity
    1301: ['replicants', 'streetsamurai', 'sprawlrats'],
    
    // New Shanghai (1302) - Asian corporate center
    1302: ['replicants', 'corpoexecs'],
    
    // Chrome City (1303) - Industrial manufacturing
    1303: ['synths', 'sprawlrats'],
    
    // Data Haven (1304) - Digital sanctuary
    1304: ['netrunners', 'rogueais', 'synths'],
    
    // Virtual Nexus (1305) - Pure cyberspace
    1305: ['netrunners', 'rogueais'],
    
    // Corporate Sector (1306) - Megacorp headquarters
    1306: ['corpoexecs', 'rogueais'],
    
    // Orbital Arcology (1307) - Elite corporate habitat
    1307: ['corpoexecs'],
    
    // Underground (1308) - Street level and below
    1308: ['streetsamurai', 'sprawlrats'],
    
    // Wasteland Outskirts (1309) - Toxic badlands
    1309: ['sprawlrats'],
    
    // Research Station (710) - Government experiments
    710: ['psychics', 'synths']
  },
  
  // Random encounter aliens (for space travel events)
  randomEncounters: [
    'sprawlrats',
    'synths',
    'replicants',
    'corpoexecs'
  ],
  
  // Hostile species that may attack on sight
  hostileSpecies: [
    'rogueais',
    'psychics'
  ],
  
  // Friendly traders willing to do business
  friendlyTraders: [
    'sprawlrats',
    'synths',
    'corpoexecs',
    'netrunners'
  ]
};

export default NeonMetropolisAliensPlanets;
